<template>
  <div>
    <p class="lead mb-1 d-flex justify-content-between">
      <span>{{ action.node_data.question }}</span>
      <span class="small">{{ action.data.timestamp }}</span>
    </p>
    <div v-if="!action.data.answer" class="d-flex justify-content-between mt-2">
      <div class="d-flex flex-wrap gap-1">
        <b-button
          variant="primary"
          size="sm"
          class="mr-1 mb-1"
          v-for="(answer, idx) in action.node_data.answer_options"
          :key="idx"
          :disabled="terminated || validating"
          @click="$emit('answer-selected', { answer, action })"
        >
          {{ answer }}
        </b-button>
      </div>
    </div>
    <div v-else>{{ $t("action_plan.viewer.answer") }}: {{ action.data.answer }}</div>
    <div class="mt-1">
      <label :for="`input-${action.id}`"> {{ $t("action_plan.viewer.comments") }} </label>
      <input
        type="text"
        :id="`input-${action.id}`"
        v-model="action.data.comments"
        class="form-control"
        :placeholder="$t('action_plan.viewer.comments')"
        :disabled="terminated || validating"
      />
    </div>
    <div class="my-1">
      <files
        v-model="action.data.files"
        :action-plan-log-uuid="actionPlanLogUuid"
        :validating="validating"
        :preview="preview"
        :terminated="terminated"
        :action="action"
        @file-added="$emit('checkpoint')"
      />
    </div>
  </div>
</template>

<script>
import Files from "./Files.vue";

export default {
  components: {Files},
  props: {
    actionPlanLogUuid: String,
    action: Object,
    terminated: Boolean,
    preview: Boolean,
    validating: Boolean,
  },
};
</script>

<style></style>
